import { actions,
         mShutterSpeedSupport,
         mShutterSpeedSupportOnShutterSpeedMode,
         mShutterSpeedSupportOnVideo,
         mWbSupport,
         mOptionSupport } from '../exports';

const getOptions = response => {
    let exposureDelay = {
      exposureProgram: 2,
      exposureProgramTitle: 'auto',
      exposureProgramIcon: 'btn--mode-auto-normal',
      auto:{
        exposureCompensation: '-2',
        _filter: 'off',
        _filterText: 'OFF'
      },
      shutter:{
        shutterSpeed: '0.00004',
        shutterSpeedText: '1/25000',
        exposureCompensation: '-2',
        whiteBalance: 'auto',
        whiteBalanceIcon: 'icon--wb_auto'
      },
      iso:{
        iso: '64',
        exposureCompensation: '-2',
        whiteBalance: 'auto',
        whiteBalanceIcon: 'icon--wb_auto'
      },
      manual:{
        aperture: '2.1',
        iso: '64',
        shutterSpeed: '0.00004',
        shutterSpeedText: '1/25000',
        whiteBalance: 'auto',
        whiteBalanceIcon: 'icon--wb_auto'
      },
      aperture:{
        aperture: '2.1',
        whiteBalance: 'auto',
        whiteBalanceIcon: 'icon--wb_auto',
        exposureCompensation: '-2'
      }
    }
    
    let options = {
      power: 'off',
      captureStatus: 'idle',
      captureMode: 'image',
      batteryLevel: '99.0',
      remainingVideoSeconds: '2601',
      image: exposureDelay,
      video: exposureDelay,
      fileFormat: '1920', 
    }

    options.power = response.power;
    options.captureStatus = response.captureStatus;
    options.captureMode = response.captureMode;
    options.batteryLevel = response.batteryLevel;
    options.remainingVideoSeconds = response.remainingVideoSeconds;
    options.fileFormat = response.fileFormat;

    if (options.captureMode === 'video') {
        options.video = setOptions(options.video,response);
    } else {
        options.image = setOptions(options.image,response);
    }    
    return options;
};

const setOptions = (options,response) => {
    const exposureProgram = getExposureProgram(response.exposureProgram);
    if (exposureProgram !== undefined) {
        options.exposureProgram = response.exposureProgram;
        options.exposureProgramTitle = exposureProgram.title;
        options.exposureProgramIcon = exposureProgram.icon;
    }
    
    switch (Number(options.exposureProgram)) {
        case 2:
            options.auto.exposureCompensation = response.exposureCompensation;
            options.auto._filter = response._filter;
            const _filter = getFilter(response._filter);
            if (_filter !== undefined) {
                options.auto._filterText = _filter[0].text;
            }
            break;
        case 3:
            options.aperture.exposureCompensation = response.exposureCompensation;
            options.aperture.whiteBalance = response.whiteBalance;
            let whiteBalance = getWhiteBalance(response.whiteBalance);
            if (whiteBalance !== undefined) {
                options.aperture.whiteBalanceIcon = whiteBalance[0].icon;
            }
            if (response.aperture !== undefined) {
                options.aperture.aperture = response.aperture;
            }
            break;
        case 4:
            options.shutter.shutterSpeed = response.shutterSpeed;
            let shutterSpeed = getShutterSpeed(response.shutterSpeed);
            if (shutterSpeed !== undefined) {
                options.shutter.shutterSpeedText = shutterSpeed[0].text;
            }
            options.shutter.exposureCompensation = response.exposureCompensation;
            options.shutter.whiteBalance = response.whiteBalance;
            whiteBalance = getWhiteBalance(response.whiteBalance);
            if (whiteBalance !== undefined) {
                options.shutter.whiteBalanceIcon = whiteBalance[0].icon;
            }
            break;
        case 9:
            options.iso.iso = response.iso;
            options.iso.exposureCompensation = response.exposureCompensation;
            options.iso.whiteBalance = response.whiteBalance;
            whiteBalance = getWhiteBalance(response.whiteBalance);
            if (whiteBalance !== undefined) {
                options.iso.whiteBalanceIcon = whiteBalance[0].icon;
            }
            break;
        case 1:
            options.manual.iso = response.iso;
            options.manual.shutterSpeed = response.shutterSpeed;
            shutterSpeed = getShutterSpeed(response.shutterSpeed);
            if (shutterSpeed !== undefined) {
                options.manual.shutterSpeedText = shutterSpeed[0].text;
            }
            options.manual.whiteBalance = response.whiteBalance;
            whiteBalance = getWhiteBalance(response.whiteBalance);
            if (whiteBalance !== undefined) {
                options.manual.whiteBalanceIcon = whiteBalance[0].icon;
            }
            if (response.aperture !== undefined) {
                options.manual.aperture = response.aperture;
            }
            break;
        
        default:
            break;
    }        
    return options;
}

const getExposureProgram = value => {
    return actions.find((item) => {
        // eslint-disable-next-line 
        return (item.val == value);
    });
}

const getWhiteBalance = value => {
    return mWbSupport.filter(function(item) {
        // eslint-disable-next-line 
        return (item.val == value);
    });
}

const getShutterSpeed = value => {
    let shutterSpeed  = mShutterSpeedSupport.filter(function(item) {
        // eslint-disable-next-line 
        return (item.val == value);
    });
    
    if (shutterSpeed === undefined) {
        shutterSpeed  = mShutterSpeedSupportOnShutterSpeedMode.filter(function(item) {
        // eslint-disable-next-line 
        return (item.val == value);
        });
    }
    
    if (shutterSpeed === undefined) {
        shutterSpeed  = mShutterSpeedSupportOnVideo.filter(function(item) {
        // eslint-disable-next-line 
        return (item.val == value);
        });
    }
    return shutterSpeed;
}

const getFilter = value => {
    return mOptionSupport.filter(function(item) {
        // eslint-disable-next-line 
        return (item.val == value);
    });
}


const getList = response => {
    const registration = [];
    const itemLength = response.resultSet.totalResult;
    for (let index = 0; index < itemLength; index++) {
        const item = response.resultSet.devices[index + ''];
        registration.push({
            serialnumber: item.serialnumber,
            devicename: item.devicename,
            comment: item.comment,
            displayname: item.displayname,
            binddate: item.binddate,
            uploadCheck:item.uploadCheck
        });
    }
    return registration;
};

const getCheck = response => {
    const itemLength = response.resultSet.totalResult;
    let checkedB = false;
    if (itemLength > 0) {
        const item = response.resultSet.devices[0];
        checkedB = item.uploadCheck;
    } 
    return checkedB;
};

const getRanking = (ranking, item, deleteFlg) => {
        if (ranking === undefined) {
            ranking = [];
            ranking.push(item);
        } else {
            const itemLength = ranking.length;
            let index = 0
            for (index = 0; index < itemLength; index++) {
                if (ranking[index].serialnumber === item.serialnumber) {
                    if (deleteFlg) {
                        ranking.splice(index, 1);
                    }
                    break;
                }
            }
            if (itemLength <= index) {
                ranking.push(item);
            }
        }
    
    return ranking;
};

const initialState = {
    category: undefined,
    ranking: undefined,
    serialnumber: undefined,
    commands: undefined,
    devicename: undefined,
    getOptions: undefined,
    videoJsOptions: undefined,
    item: undefined,
    uploadCheck: false,
    error: false,
    statusCode:undefined
};
 
 
export default(state = initialState, action) => {
    switch(action.type){
        case 'START_BIND_REQUEST':
            return {
                category: action.payload.category,
                ranking: undefined,
                error: false
            };
        case 'RECEIVE_BIND_DATA':
            return action.payload.error
            ?{...state,error:true}
            :{
                ...state,
                ranking: getList(action.payload.response),
                checkedB: getCheck(action.payload.response)
            };
        case 'START_BIND_POST':
            return {
                category: action.payload.category,
                serialnumber: action.payload.serialnumber,
                devicename: action.payload.devicename,
                error: false
            };
        case 'FINISH_BIND_POST':
            return action.payload.error
            ?{...state,error:true}
            :{
                ...state,
                ranking: getRanking(action.payload.ranking,action.payload.item,action.payload.deleteFlg),
                checkedB: action.payload.uploadCheck
            };
        case 'START_SHOOTING_REQUEST':
            return {
                category: action.payload.category,
                options: undefined,
                error: false
            };
        case 'RECEIVE_SHOOTING_DATA':
            return action.payload.error
            ?{...state,error:true}
            :{
                ...state,
                getOptions: getOptions(action.payload.response)
            };
        case 'START_SHOOTING_POST':
            return {
                category: action.payload.category,
                commands: action.payload.commands,
                error: false
            };
        case 'FINISH_SHOOTING_POST':
            return action.payload.error
            ?{...state,error:true}
            :{
                ...state,
                commands: action.payload.commands
            };
        case 'START_UNSUBSCRIBE_ACCOUNT':
        return {
                category: action.payload.category,
            };
        case 'FINISH_UNSUBSCRIBE_ACCOUNT':
        return {
                statusCode: action.payload.statusCode,
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/ThetaBindList.js